import React from 'react';
import './style.css';

const Applications = () => {
    return(
        <div className="applications-area section-padding">
            <div className="container">
                <div className="col-12">
                    <div className="section-title text-center">
                        <span>Başvurular</span>
                        <h2>İş Başvuru Formu</h2>
                    </div>
                </div>
                {/* Başvuru formu içeriği buraya gelecek */}
            </div>
        </div>
    )
}

export default Applications; 